<template>
  <header class="navbar-header">
    <div class="container">
      <router-link to="/">
        <img src="/skroutz-last-mile-logo.svg" alt="skroutz last mile logo" />
      </router-link>
      <div class="merchantName">
        <h1 v-if="!!merchantName === true">Welcome! {{ merchantName }}</h1>
      </div>
    </div>
    <div class="locale-dropdown" @click.stop>
      <button class="locale-trigger" @click="toggleMenu" :aria-expanded="isOpen">
        <svg
          class="globe-icon"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.5" />
          <ellipse
            cx="12"
            cy="12"
            rx="4"
            ry="10"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="1.5" />
          <line x1="4.5" y1="6.5" x2="19.5" y2="6.5" stroke="currentColor" stroke-width="1.5" />
          <line x1="4.5" y1="17.5" x2="19.5" y2="17.5" stroke="currentColor" stroke-width="1.5" />
        </svg>
        <span class="locale-label">{{ currentLocaleLabel }}</span>
        <svg
          class="chevron"
          :class="{ open: isOpen }"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M6 9l6 6 6-6"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <ul v-if="isOpen" class="locale-menu" :style="menuStyle" role="listbox">
        <li
          v-for="option in localeOptions"
          :key="option.value"
          class="locale-option"
          :class="{ active: $i18n.locale === option.value }"
          role="option"
          :aria-selected="$i18n.locale === option.value"
          @click="selectLocale(option.value)"
        >
          <span>{{ option.label }}</span>
          <svg
            v-if="$i18n.locale === option.value"
            class="check-icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M5 13l4 4L19 7"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    merchantName: String,
  },
  data() {
    return {
      isOpen: false,
      menuStyle: {},
      localeOptions: [
        { value: 'el', label: 'Ελληνικά (EL)' },
        { value: 'en', label: 'English (EN)' },
      ],
    };
  },
  computed: {
    currentLocaleLabel() {
      return this.$i18n.locale === 'el' ? 'EL' : 'EN';
    },
  },
  methods: {
    toggleMenu() {
      if (!this.isOpen) {
        const rect = this.$el.querySelector('.locale-trigger').getBoundingClientRect();
        this.menuStyle = {
          top: rect.bottom + 6 + 'px',
          right: window.innerWidth - rect.right + 'px',
        };
      }
      this.isOpen = !this.isOpen;
    },
    selectLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
      this.isOpen = false;
    },
    handleOutsideClick() {
      this.isOpen = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
};
</script>

<style scoped>
.navbar-header {
  display: flex;
  align-items: center;
  padding-right: 16px;
}
header img {
  width: 135px;
}
header .container {
  width: 94%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
header .merchantName {
  flex: 1;
  text-align: center;
}

.locale-dropdown {
  flex-shrink: 0;
}

.locale-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f1f3f5;
  border: 1px solid #dee2e6;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #212529;
  transition: background 0.15s ease;
  margin-left: auto;
  max-width: fit-content;
}
.locale-trigger:hover {
  background: #e9ecef;
}

.globe-icon {
  width: 16px;
  height: 16px;
  color: #495057;
}

.locale-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1;
}

.chevron {
  width: 14px;
  height: 14px;
  color: #495057;
  transition: transform 0.2s ease;
}
.chevron.open {
  transform: rotate(180deg);
}

.locale-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  min-width: 180px;
  z-index: 9999;
}

.locale-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #212529;
  cursor: pointer;
  transition: background 0.1s ease;
}
.locale-option:hover {
  background: #f8f9fa;
}
.locale-option.active {
  font-weight: 700;
}

.check-icon {
  width: 16px;
  height: 16px;
  color: #212529;
  flex-shrink: 0;
}

@media (min-width: 961px) {
  header .container {
    max-width: unset;
  }
}
</style>
